<template lang="pug">
  .address-list
    .address-list__picker-container
      Selectpicker(
        v-if="addresses.length"
        :options="addresses"
        :show-button="true"
        placeholder="Выберите адрес"
        button-text="Выбрать"
        v-model="addressId"
        @change="pickAddress"
        @input="applyAddress"
        @clear="clearAddress"
      )
    LMap(
      :zoom="zoom"
      @ready="onMapReady"
      @locationfound="onMapLocationFound"
    )
      l-marker(
        v-for="address in addresses"
        :key="address.id"
        :lat-lng="address.latlng"
        :icon="addressId !== address.id ? icon : iconActive"
        @click="pickAddress(address.id)"
      )
      l-tile-layer(:url="url" :attribution="attribution")
</template>

<script>
import {mapGetters, mapActions} from "vuex";
import Selectpicker from "@/components/Selectpicker"
import icon from '../assets/png/map-marker-purple.png'
import iconActive from '../assets/png/map-marker-gold.png'
import L from 'leaflet';
import {
  LMap,
  LTileLayer,
  LMarker,
  LControlAttribution
} from 'vue2-leaflet';

export default {
  name: 'AddressList',
  components: {
    LMap,
    LTileLayer,
    LMarker,
    LControlAttribution,
    Selectpicker,
  },
  data() {
    return {
      mapObject: undefined,
      mapCenter: undefined,
      zoom: 11,
      url: 'http://{s}.tile.osm.org/{z}/{x}/{y}.png',
      attribution: '&copy; <a target="_blank" href="http://osm.org/copyright">OpenStreetMap</a> contributors',
      icon: L.icon({
        iconUrl: icon,
        iconSize: [30.5, 34],
        iconAnchor: [15.25, 34],
      }),
      iconActive: L.icon({
        iconUrl: iconActive,
        iconSize: [30.5, 34],
        iconAnchor: [15.25, 34],
      }),
      addressId: null,
    }
  },
  computed: {
    ...mapGetters('address', {
      rawAddresses: 'getAddresses',
      currentAddress: 'getCurrentAddress',
      getAddressById: 'getAddressById',
    }),
    addresses() {
      return this.rawAddresses.map(address => ({
        id: address.id,
        value: address.id,
        name: address.formatted_address,
        latlng: address.location,
      }));
    },
  },
  watch: {
    /**
     * По подгрузке адресов (и если готова карта):
     * - установить центр карты на 1 адрес
     * - установить первый адрес как текущий выбранный
     */
    addresses(newVal, oldVal) {
      if (oldVal.length === 0 && newVal.length && this.mapObject) {
        this.setView();
        this.setAddressId();
      }
    }
  },
  methods: {
    ...mapActions('address', [
      'clearAddressDependencies',
      'fetchAddresses',
      'setCurrentAddress'
    ]),
    onMapReady(mapObject) {
      mapObject.setZoom(2);
      mapObject.attributionControl.setPosition('topright');
      mapObject.zoomControl.setPosition('topright');
      this.mapObject = mapObject;

      /**
       * По готовности карты (и если адреса уже загружены):
       * - установить центр карты на 1 адрес
       * - установить первый адрес как текущий выбранный
       */
      if (this.addresses.length) {
        this.setView();
        this.setAddressId();
      }
    },
    onMapLocationFound(location) {
      this.mapCenter = Object.values(location.latlng);
    },
    pickAddress(addressId) {
      this.addressId = addressId;
      this.mapObject.flyTo(Object.values(this.getAddressById(addressId).location), 14);
    },
    clearAddress() {
      this.addressId = null;
      this.mapObject.flyTo(this.mapCenter, this.zoom);
    },
    applyAddress(addressId) {
      this.setCurrentAddress(addressId);
      this.clearAddressDependencies();
      this.$router.push('/');
    },
    setView() {
      this.mapCenter = this.currentAddress?.location || this.addresses[0].latlng;
      this.mapObject.setView(this.mapCenter, this.zoom);
    },
    setAddressId() {
      this.addressId = this.currentAddress?.addressId || this.addresses[0].id;
    }
  }
}
</script>
